// src/components/common/CommonImage.js
import * as React from 'react';

import Avatar from '@mui/material/Avatar';
import Link from '@mui/material/Link';

import * as WrcCommon from '@webrcade/app-common'
import { dropHandler } from '../../Drop';
import { usePrevious } from '../../Util';

// 🔹 i18n
import { useI18n } from '../../i18n/I18nContext';

export default function CommonImage(props) {
  const {
    defaultImageSrc,
    requiredAspectRatio,
    errorCallback,
    onDropText,
    sx
  } = props;

  const { t } = useI18n(); // hook de tradução

  let imageSrc = props.imageSrc;
  if (imageSrc) imageSrc = WrcCommon.remapUrl(imageSrc);

  const [img, setImg] = React.useState(null);
  const prevValues = usePrevious({
    imageSrc, defaultImageSrc, requiredAspectRatio
  });

  React.useEffect(() => {
    if (
      !prevValues ||
      imageSrc !== prevValues.imageSrc ||
      defaultImageSrc !== prevValues.defaultImageSrc ||
      requiredAspectRatio !== prevValues.requiredAspectRatio
    ) {
      const tempImg = new Image();

      tempImg.onload = (e) => {
        const target = e.target;

        let arTarget = 1;
        let arReq = 1;

        if (requiredAspectRatio) {
          arTarget = (target.naturalWidth / target.naturalHeight).toFixed(2);
          arReq = (requiredAspectRatio[0] / requiredAspectRatio[1]).toFixed(2);
        }

        if (requiredAspectRatio && arTarget !== arReq) {
          // 🔹 Mensagem traduzida
          const msg = (
            <>
              {t("commonImageAspectRatioWarning", {
                ratio: `${requiredAspectRatio[0]}:${requiredAspectRatio[1]}`
              })}
              &nbsp;&nbsp;
              <Link
                underline="none"
                href="https://www.birme.net/?target_width=400&target_height=300&auto_focal=false"
                target="_blank"
              >
                (Birme)
              </Link>
              &nbsp;
              <Link
                underline="none"
                href="https://onlinepngtools.com/fit-png-in-rectangle"
                target="_blank"
              >
                (Rect Fitter)
              </Link>
            </>
          );

          if (errorCallback) errorCallback(msg);
          setImg(target.src);
        } else {
          if (errorCallback) errorCallback(null);
          setImg(target.src);
        }
      };

      tempImg.onerror = () => {
        if (errorCallback)
          errorCallback(t("commonImageNotFound"));
        setImg(defaultImageSrc);
      };

      tempImg.src = WrcCommon.isValidString(imageSrc)
        ? imageSrc
        : defaultImageSrc;
    }
  }, [
    imageSrc,
    defaultImageSrc,
    setImg,
    errorCallback,
    requiredAspectRatio,
    prevValues,
    t
  ]);

  return (
    <Avatar
      variant="rounded"
      onDrop={(e) => {
        if (onDropText) {
          e.preventDefault();
          dropHandler(e, (text) => {
            onDropText(text);
          });
        }
      }}
      sx={{
        backgroundColor: 'black',
        ...sx
      }}
      src={img}
    >
      &nbsp;
    </Avatar>
  );
}